import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProductId} from "../../../products/product-id";
import { productIdZodSchema } from "../../../products/product-id";
import type {
    ExternalAccessId} from "../external-access-id";
import {
    externalAccessIdZodSchema,
} from "../external-access-id";

type RemoveExternalAccessToProductId = Branded<
    string,
    "RemoveExternalAccessToProductId"
>;
const {
    factory: RemoveExternalAccessToProductIdFactory,
    zodSchema: RemoveExternalAccessToProductIdZodSchema,
} = genericId<RemoveExternalAccessToProductId, "block__">("block__");

// type RemoveExternalAccess =
//     | { type: "PARAKEY"; keyID: string }
//     | { type: "PASSCODE"; code: string };

type RemoveExternalAccessToProduct = {
    _id: string;
    _createdAt: IsoAndUnixTimestamp;
    _type: "REMOVE_EXTERNAL_ACCESS_TO_PRODUCT";
    providerId: ProviderId;
    productId: ProductId;
    accessId: ExternalAccessId;
};

type FactoryParams = Except<
    RemoveExternalAccessToProduct,
    "_id" | "_type" | "_createdAt"
>;
const removeExternalAccessToFactory = (params: FactoryParams) => {
    const command: RemoveExternalAccessToProduct = {
        ...params,
        _id: RemoveExternalAccessToProductIdFactory(),
        _type: "REMOVE_EXTERNAL_ACCESS_TO_PRODUCT",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const removeExternalAccessToProductZodSchema: z.ZodSchema<RemoveExternalAccessToProduct> =
    z.object({
        _id: RemoveExternalAccessToProductIdZodSchema,
        _type: z.literal("REMOVE_EXTERNAL_ACCESS_TO_PRODUCT"),
        _createdAt: isoAndUnixZodSchema,
        productId: productIdZodSchema,
        providerId: providerIdZodSchema,
        accessId: externalAccessIdZodSchema,
    });

export {
    removeExternalAccessToFactory,
    removeExternalAccessToProductZodSchema,
};
export type { RemoveExternalAccessToProduct };
